<template>
  <div>
    <b-form-group
      v-if="showType == 'form-builder'"
      :description="properties.description"
      :label="properties.question"
      :style="properties.style"
    >
      <b-form-radio-group :stacked="!properties.showInline">
        <b-form-radio
          :value="value"
          :key="index"
          :class="properties.showInline ? 'mr-3' : ''"
          v-for="({ text, value }, index) in properties.answers"
        >
          {{ text }} ({{ value }})
        </b-form-radio>
      </b-form-radio-group>
    </b-form-group>
    <div v-if="showType == 'properties'">
      <assessment-question-v1-properties :formId="formId" />
    </div>
    <b-form-group
      style="font-size: 14px"
      v-if="
        (showType == 'form-submitter' && page == currentPage) ||
          (showType == 'e-form' && properties.eFormEditable)
      "
      :description="
        computedConditions.description
          ? computedPropertiesForm.description
          : properties.description
      "
      :label="
        computedConditions.question
          ? computedPropertiesForm.question
          : properties.question
      "
      :style="properties.style"
      :hidden="computedHidden"
      :state="state"
      :invalid-feedback="errors.join(', ')"
    >
      <b-form-radio-group
        v-model="controlValue"
        :stacked="!properties.showInline"
      >
        <b-form-radio
          style="font-size: 14px"
          :value="answer"
          :key="index"
          :class="properties.showInline ? 'mr-3' : ''"
          v-for="(answer, index) in computedConditions.answers
            ? computedPropertiesForm.answers
            : properties.answers"
        >
          {{ answer.text }}
        </b-form-radio>
      </b-form-radio-group>
    </b-form-group>
    <b-form-group
      v-if="
        showType == 'form-viewer' ||
          (showType == 'e-form' && !properties.eFormEditable)
      "
      :label="
        computedConditions.question
          ? computedPropertiesForm.question
          : properties.question
      "
      :style="properties.style"
    >
      <div :class="properties.showInline ? 'd-flex flex-row flex-wrap' : ''">
        <div
          :value="value"
          :key="optionIndex"
          v-for="({ text, value }, optionIndex) in computedConditions.answers
            ? computedPropertiesForm.answers
            : properties.answers"
          class="mr-3"
        >
          <b-icon-check-circle-fill
            class="text-primary"
            v-if="controlValue.value == value"
          /><b-icon-circle v-else /> {{ text }}
        </div>
      </div>
    </b-form-group>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState, mapActions } from "vuex";
import AssessmentQuestionV1Properties from "./AssessmentQuestionV1Properties.vue";

export default {
  name: "AssessmentQuestionV1",
  components: { AssessmentQuestionV1Properties },
  props: ["showType", "properties", "form", "id", "results", "formId", "page", "componentsIdSuffix"],
  data() {
    return {
      computedProperties: ["description", "question", "hidden", "answers"],
      computedConditions: {},
      toWatch: {
        hidden: null
      }
    };
  },
  mounted() {
    if (this.showType == "form-submitter" || this.showType == "e-form") {
      this.setFormSubmitterComponentMetadata({
        controlId: this.id,
        controlMetadata: {
          question: this.properties.question,
          label: this.properties.question
        }
      });
      if(this.componentsIdSuffix) {
        this.initializeComponentValue({
          controlId: this.id,
          properties: this.properties
        });
      }
    }

    this.computeConditions();
  },
  methods: {
    ...mapMutations("formSubmitter", ["setFormSubmitterComponentMetadata"]),
    ...mapActions("formSubmitter", ["setFormSubmitterComponentValue", "computeFormSubmitterValue", "initializeComponentValue"]),
    computeConditions() {
      const computedConditions = {};
      for (let index = 0; index < this.computedProperties.length; index++) {
        const property = this.computedProperties[index];
        computedConditions[property] =
          typeof this.properties[property] == "string" &&
          this.properties[property].includes("{{");
      }
      this.computedConditions = computedConditions;
    },

    getComponentComputedProperties(property) {
      return this.computedPropertiesForm
        ? this.computedPropertiesForm[property] != null
          ? this.computedPropertiesForm[property]
          : this.properties[property]
          ? this.properties[property]
          : ""
        : this.properties[property]
        ? this.properties[property]
        : "";
    },
    getBakedLayout() {
      const hidden = this.getComponentComputedProperties(
        "hidden"
      );

      if(hidden === true)
        return "";
        
      return `
      <fieldset aria-describedby="" class="form-group">
        <legend style="font-size: 14px" tabindex="-1" class="bv-no-focus-ring col-form-label pt-0">
        ${this.getComponentComputedProperties("question")}
        </legend>
        <div tabindex="-1" role="group" class="bv-no-focus-ring">
          <div class="${
            this.properties.showInline ? "d-flex flex-row flex-wrap" : ""
          }">
            ${(this.getComponentComputedProperties("answers") || [])
              .map(
                answer => `
            <div style="font-size: 14px" class="mr-3">
              ${
                this.controlValue?.text == answer.text &&
                this.controlValue?.value == answer.value
                  ? '<i class="fas fa-check-circle text-primary"></i>'
                  : '<i class="far fa-circle"></i>'
              }
          
              ${answer.text} 
            </div>
            `
              )
              .join("")}
          </div>
        </div>
      </fieldset>`;
    }
  },
  computed: {
    ...mapState("formSubmitter", {
      formErrors: state => state.form.errors,
      currentPage: state => state.form.currentPage
    }),
    ...mapGetters("formSubmitter", [
      "getFormSubmitterComponentValue"
    ]),
    computedPropertiesForm() {
      return this.$store.state.formSubmitter.form.computedProperties[this.id] ?? this.properties;
    },
    controlValue: {
      get() {
        if (this.results) return this.results[this.id];
        return this.getFormSubmitterComponentValue(this.id);
      },
      set(newControlValue) {
        if (this.controlValue != newControlValue) {
          this.setFormSubmitterComponentValue({
            controlId: this.id,
            controlValue: newControlValue,
            userAction: true
          });
          this.$emit("update-child-control-value", {
            controlId: this.id,
            controlValue: newControlValue
          });
          if (this.properties.onChange) {
            this.computeFormSubmitterValue({
              elementId: this.id,
              property: "onChange",
              value: `computed:(${this.properties.onChange})(${JSON.stringify(
                newControlValue
              )})`,
              defaultValue: null,
              form: this.form,
              statements: true
            });
          }
        }
      }
    },
    errors: {
      get() {
        return this.formErrors[this.id] ? this.formErrors[this.id] : [];
      }
    },
    state: {
      get() {
        return this.errors.length == 0 ? null : false;
      }
    },
    computedHidden() {
      const hiddenValue = this.computedConditions.hidden
        ? this.computedPropertiesForm.hidden
        : this.properties.hidden

      this.$emit("change-hidden-property", hiddenValue);
      return hiddenValue;
    }
  }
};
</script>
